import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import styles from './Settings.module.css';
import { logoutAction } from '../../redux/user/actions.js';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

function Settings() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const [isDarkMode, setIsDarkMode] = useState(false)

  const user_email = useSelector((state) => state.user.email)

  /* useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') {
      document.body.classList.add('dark-mode');
      setIsDarkMode(true)
    }
  }, []); */

  /* const handleThemeToggle = () => {
    setIsDarkMode(!isDarkMode);
    if (!isDarkMode) {
      document.body.classList.add('dark-mode');
      localStorage.setItem('theme', 'dark');
    } else {
      document.body.classList.remove('dark-mode');
      localStorage.setItem('theme', 'light');
    }
  }; */

  const handleLogout = () => {
    dispatch(logoutAction());
    navigate('/');
  }

  return (
    <div className={styles.settings}>
      <div className={styles.header}>
        <h1>Settings</h1>
      </div>
      <div className={styles.section}>
        <h2>Account</h2>
        <div className={styles.item}>
          <h3>Email</h3>
          <p>{user_email}</p>
        </div>
        <div className={styles.item}>
          <button className={styles.logoutButton} onClick={handleLogout}>Logout</button>
        </div>
        <br></br>
      </div>

      {/* <div className={styles.section}>
        <h2>Appearance</h2>
        <div className={styles.item}>
          <h3>Theme</h3>
          <button className={styles.themeToggle} onClick={handleThemeToggle}>
            {isDarkMode ? 'Light Mode' : 'Dark Mode'}
          </button>
        </div>
        <br></br>
      </div> */}
      <p>Reach out to <a href="mailto:wgay7@gatech.edu" target="_blank" rel="noreferrer">William Gay</a> to provide feedback or get involved!</p>
    </div>
    
  );
}

export default Settings;
